// src/components/CookieConsent.js
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const CookieConsent = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    // Check if cookies have already been accepted
    if (!Cookies.get('cookiesAccepted')) {
      setShowCookieBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    // Set the cookie for 30 days
    Cookies.set('cookiesAccepted', 'true', { expires: 30 });
    setShowCookieBanner(false);
  };

  return (
    showCookieBanner && (
      <div className="cookie-banner">
        <p>
          We use cookies to enhance your experience. By continuing to visit this site, you agree to our use of cookies.
        </p>
        <button onClick={acceptCookies}>Accept</button>
      </div>
    )
  );
};

export default CookieConsent;

















